"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {FriendlyCaptchaSDK} from "@friendlycaptcha/sdk";

const defaultSelectors = {
    base: '.js-friendly-captcha',
    submit: '.js-friendly-captcha-submit'
};

let sdk;

export function init(selectors = defaultSelectors) {
    onFind(selectors.base, function (element) {
        let form = element.closest('form');
        let submitBtn = form ? form.querySelector(selectors.submit) : null;

        if (submitBtn) {
            submitBtn.disabled = true;
        }

        if (!sdk) {
            sdk = new FriendlyCaptchaSDK();
        }

        let widget = sdk.createWidget({
            element: element,
            sitekey: element.getAttribute('data-sitekey'),
            startMode: 'none'
        });

        widget.addEventListener('frc:widget.complete', () => {
            if (submitBtn) {
                submitBtn.disabled = false;
            }
        });
        widget.addEventListener('frc:widget.error', () => {
            if (submitBtn) {
                submitBtn.disabled = true;
            }
        });
        widget.addEventListener('frc:widget.expire', () => {
            if (submitBtn) {
                submitBtn.disabled = true;
            }
        });
    });
}
